/** Push a custom event for Google Tag Manager (`Trigger type: Custom Event`). */
export function pushGtmEvent(
  event: string,
  extra?: Record<string, unknown>
): void {
  window.dataLayer = window.dataLayer ?? []
  window.dataLayer.push({ event, ...extra })
}

/**
 * Fires the Google Ads conversion loaded via `gtag.js` in `index.html`.
 * Google Ads “Tag Assistant” / conversion diagnostics listen for this.
 * If you later add a Google Ads conversion tag in GTM on the `signup` event,
 * remove this call to avoid double-counting.
 */
export function fireGoogleAdsSignupConversion(): void {
  window.gtag?.('event', 'conversion', {
    send_to: 'AW-11544603002/IvFGCPS1jaoaEPrS8oAr',
    value: 1.0,
    currency: 'NZD'
  })
}
